import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Descriptions, Form, Input, Modal, Tag } from 'antd'
import {
  NOTE_MAX_LENGTH,
  TRANSACTION_STATUS,
  formatAmount,
  formatBangkokDateTime
} from '../../../../../../modules/brandActivityTransaction'
import EvidenceImage from '../EvidenceImage'

const display = (value) =>
  value === undefined || value === null || value === '' ? '-' : value

const nameWithId = (name, id) => (name ? `${name} (#${id})` : '-')

const statusLabel = (value) => {
  const status = TRANSACTION_STATUS.find((item) => item.value === value)
  return status ? status.label : display(value)
}

// แก้ได้เฉพาะ note (บันทึกที่ BrandHero ของ hero นั้น)
const TransactionForm = (props) => {
  const { visible, formState, loading, onOk, onCancel, form } = props
  const { getFieldDecorator, validateFields, resetFields } = form
  const record = formState || {}
  const hasHero = !!record.heroId

  useEffect(() => {
    if (visible) {
      resetFields()
    }
  }, [visible, formState])

  const buildBody = (values) => {
    const body = {}
    const note = values.note || ''
    if (hasHero && note !== (record.brandHeroNote || '')) {
      // "" = ล้างหมายเหตุ
      body.note = note
    }
    return body
  }

  const onSubmit = () => {
    validateFields((err, values) => {
      if (!err) {
        onOk(buildBody(values))
      }
    })
  }

  return (
    <Modal
      width={800}
      title={`แก้ไข Transaction #${display(record.id)}`}
      visible={visible}
      onOk={onSubmit}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="บันทึก"
      cancelText="ยกเลิก"
      maskClosable={false}
    >
      <Descriptions bordered size="small" column={2}>
        <Descriptions.Item label="วันเวลา">
          {formatBangkokDateTime(record.createdDate)}
        </Descriptions.Item>
        <Descriptions.Item label="วัสดุ">
          {display(record.materialName)}
        </Descriptions.Item>
        <Descriptions.Item label="User">
          {nameWithId(record.userName, record.userId)}
        </Descriptions.Item>
        <Descriptions.Item label="Hero">
          {nameWithId(record.heroName, record.heroId)}
        </Descriptions.Item>
        <Descriptions.Item label="จำนวน">
          {formatAmount(record)}
        </Descriptions.Item>
        <Descriptions.Item label="Location">
          {display(record.locationName)}
        </Descriptions.Item>
        <Descriptions.Item label="บาร์โค้ด">
          {display(record.barcode)}
        </Descriptions.Item>
        <Descriptions.Item label="สถานะ">
          <Tag>{statusLabel(record.status)}</Tag>
        </Descriptions.Item>
      </Descriptions>
      <div style={{ marginTop: 16 }}>
        <div style={{ marginBottom: 8 }}>รูปภาพหลักฐาน</div>
        <EvidenceImage images={[record.weighingImage]} />
      </div>
      <Form layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          label="หมายเหตุ"
          extra={
            hasHero
              ? 'หมายเหตุนี้ผูกกับ Brand Hero ของกิจกรรมนี้ทุกรายการ'
              : 'รายการนี้ไม่มี Hero จึงเพิ่มหมายเหตุไม่ได้'
          }
        >
          {getFieldDecorator('note', {
            initialValue: record.brandHeroNote || '',
            rules: [
              {
                max: NOTE_MAX_LENGTH,
                message: `หมายเหตุต้องไม่เกิน ${NOTE_MAX_LENGTH} ตัวอักษร`
              }
            ]
          })(
            <Input.TextArea
              rows={3}
              maxLength={NOTE_MAX_LENGTH}
              disabled={!hasHero}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}

TransactionForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  formState: PropTypes.object,
  loading: PropTypes.bool,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedTransactionForm = Form.create({
  name: 'BrandActivityTransactionForm'
})(TransactionForm)
export default WrappedTransactionForm
